/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
//@ts-nocheck
import React, { useState } from 'react';
import { FaArrowCircleLeft } from 'react-icons/fa';
import { MdCancel } from 'react-icons/md';
import Col from 'react-bootstrap/Col';
import { useTheme } from '../../../../providers/theme';
import * as S from './style';

export interface IProgressBar {
  ProgressBarSteps?: string[];
  stepsTitle?: string;
  totalSteps: number;
  activeStep: number;
  onCloseClick?(): void;
  onActiveStepChange(step?: number): void;
}

export const ProgressBar = (props: IProgressBar) => {
  const theme = useTheme();
  const {
    ProgressBarSteps,
    stepsTitle,
    totalSteps,
    activeStep,
    onCloseClick,
    onActiveStepChange,
  } = props;

  let fillerWidth = (100 / totalSteps) * activeStep;

  const onPreviousClick = () => {
    onActiveStepChange && onActiveStepChange();
  };

  return (
    <>
      <S.Container>
        <S.HeaderRow>
          <Col lg={1} xs={2} sm={1}>
            <S.Previous
              disabled={activeStep === 0 || activeStep === totalSteps}
              onClick={onPreviousClick}
            >
              <FaArrowCircleLeft />
            </S.Previous>{' '}
          </Col>
          <Col lg={5} xs={8} sm={6}>
            <S.Heading>{ProgressBarSteps[activeStep]} </S.Heading>
          </Col>
          <Col lg={5} sm={3} className="d-none d-sm-block">
            <S.Step>
              {stepsTitle} {activeStep + 1} out of {totalSteps + 1}
            </S.Step>
          </Col>
          <Col lg={1} xs={2} sm={2}>
            <S.Cancel
              onClick={onCloseClick}
              disabled={activeStep === totalSteps}
            >
              <MdCancel />
            </S.Cancel>
          </Col>
        </S.HeaderRow>
        <S.Containers>
          <S.FillerStyle
            fillWidth={fillerWidth}
            color={theme?.colors?.secondary}
          />
        </S.Containers>
      </S.Container>
    </>
  );
};
ProgressBar.defaultProps = {
  ProgressBarSteps: ['Select Template', 'Create Campaign'],
  stepsTitle: 'Step',
  totalSteps: 1,
  activeStep: 1,
};
